import styled from 'styled-components/macro';

const PhotoFigure = styled.figure`
  width: 100%;
  margin: 0;
  padding-left: 136px;
  padding-bottom: 23px;
`;

export default PhotoFigure;
